export enum AttractionIndoorOutdoorEnum {
    INDOOR = 'indoor',
    OUTDOOR = 'outdoor',
    MIXED = 'mixed',
}
